var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.217 23.105"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-calendar-day",
    d: "M0 20.939A2.167 2.167 0 002.166 23.1h15.885a2.167 2.167 0 002.166-2.166V8.664H0zm2.888-8.664a.724.724 0 01.722-.722h4.332a.724.724 0 01.722.722v4.332a.724.724 0 01-.722.722H3.61a.724.724 0 01-.722-.722zm15.163-9.387h-2.166V.722A.724.724 0 0015.163 0h-1.444A.724.724 0 0013 .722v2.166H7.22V.722A.724.724 0 006.5 0H5.054a.724.724 0 00-.722.722v2.166H2.166A2.167 2.167 0 000 5.054V7.22h20.217V5.054a2.167 2.167 0 00-2.166-2.166z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "365fd967fba56c8ac03aa98eefec56be.svg";
export { SvgCalendar as ReactComponent };